import { router, useGlobalSearchParams } from "expo-router";
import { useQueryClient } from "@tanstack/react-query";
import type { SubmitHandler } from "react-hook-form";

import { api } from "~/utils/api";
import img from "~/assets/signup/signup-1.png";
import type { SignupFormData } from "~/component/feature/auth/signup-form";
import { SignupForm } from "~/component/feature/auth/signup-form";
import {
  AuthCodeWrapper,
  AuthContainer,
  AuthContent,
  AuthImage,
} from "~/component/feature/auth/wrappers";
import { AuthLayout } from "~/component/layout/layout";

export default function SignupCodePage() {
  const { code } = useGlobalSearchParams<{ code: string }>();
  const apiUtils = api.useUtils();
  const queryClient = useQueryClient();

  const {
    mutate,
    error: mutationError,
    isError: mutationIsError,
  } = api.authRouter.signup.useMutation({
    onSuccess: async () => {
      queryClient.clear();
      await apiUtils.context.person.fetch();
      router.replace("/");
    },
  });

  const onSubmit: SubmitHandler<SignupFormData> = (data) => {
    mutate({ ...data, code });
  };

  const { data, isError } = api.authRouter.checkCode.useQuery(
    { code },
    {
      refetchInterval: false,
      refetchIntervalInBackground: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  );

  return (
    <AuthLayout>
      <AuthContainer>
        <AuthContent>
          <AuthCodeWrapper data={data} isError={isError}>
            <SignupForm
              withPhone
              email={data?.email}
              onSubmit={onSubmit}
              isError={mutationIsError}
              errorMessage={mutationError?.message}
            />
          </AuthCodeWrapper>
        </AuthContent>
        <AuthImage src={img} />
      </AuthContainer>
    </AuthLayout>
  );
}
